// Formula-injection-safe CSV cell escaper — shared across the CPSC CSV export sites (CHA-193 consolidation).
// Neutralizes a leading formula byte AND a whitespace/newline-prefixed formula (spreadsheets still evaluate
// " =CMD" / "\n=CMD" after trimming), then quotes any cell containing a quote / comma / CR / LF.
// Client copy; the server runtime has an identical CommonJS mirror at functions/platform/csvSafe.js
// (client and Cloud Functions bundles can't share one module).
export function escCsv(v) {
  let str = String(v ?? '');
  if (/^[=+\-@\t\r]/.test(str) || /^\s+[=+\-@]/.test(str)) str = `'${str}`;
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}
